import { FutebolRuleSetStrategy } from './FutebolRuleSetStrategy';
import { RuleSetStrategy } from './RuleSetStrategy';

export const strategyMap: Record<string, new () => RuleSetStrategy> = {
  Futebol : FutebolRuleSetStrategy,
};
